import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { FeatureFlags, FeatureName, ScriptStatus } from '../../types/featureFlags';
import { loadScript, removeScript } from '../../helpers/scriptLoader';
import { setScriptStatus } from '../../store/scriptStatusSlice';

interface Props {
    features: FeatureFlags;
}

const DynamicScripts: React.FC<Props> = ({ features }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        (Object.keys(features) as FeatureName[]).forEach((key) => {
            const flag = features[key];
            const id = `feature-${key}`;

            if (!flag.enabled) {
                removeScript(id);
                dispatch(setScriptStatus(key, ScriptStatus.Idle));
                return;
            }

            dispatch(setScriptStatus(key, ScriptStatus.Loading));
            const content = flag.type === 'inline' ? atob(flag.content) : flag.content;

            loadScript(flag.position, content, id, flag.type)
                .then(() => dispatch(setScriptStatus(key, ScriptStatus.Completed)))
                .catch(() => dispatch(setScriptStatus(key, ScriptStatus.Failed)));
        });
    }, [features, dispatch]);

    return null;
};

export default DynamicScripts;
